import { px } from "framer-motion";

export const customStyles = {
  tableWrapper: {
    style: {
      backgroundColor: "#FFFBF4",
      paddingLeft: '0px',
      paddingRight : '0px',
      borderRadius: "12px",
      overflow: "hidden",
    },
  },

  headRow: {
    style: {
      backgroundColor: "#D9A128",
      minHeight: "52px",
      borderBottom: "none",
    },
  },

  headCells: {
    style: {
      color: "#ffffff",
      fontWeight: "600",
      backgroundColor: "#D9A128",
      justifyContent: "flex-start",   // 🔥 ADD THIS
      textAlign: "left",  
      paddingLeft: '0px',
      paddingRight : '0px',        
      borderRight: "none",
    },
  },

  rows: {
    style: {
      backgroundColor: "#FFFBF4",
      borderBottom: "none",      // ❌ remove grey line
    },
  },

  cells: {
    style: {
      backgroundColor: "#FFFBF4",
      color: "#333",
      justifyContent: "flex-start",   // 🔥 ADD THIS
      textAlign: "left",              
      borderRight: "none",
      padding:"3px",       // ❌ remove grey dividers
    },
  },

  pagination: {
    style: {
      backgroundColor: "#FFFBF4",
      borderTop: "none",         // ❌ remove grey top line
    },
  },
};
